import { createThemeStore } from '@jarvis/platform-ui';

export const { useThemeStore, bootstrapTheme } = createThemeStore({
  storageKey: 'webopsui:theme'
});
